import { useEffect } from "react";
import { ghlAffiliate } from "src/libs/ghl-affiliate";
import { WhiteLabelProfessionalGroup } from "src/types/snugtotal";

// Injects the GHL Affiliate Manager visitor script once the firm's
// white-label config is known — only for firms with the feature enabled.
export const useGhlAffiliate = (
  professionalGroup: WhiteLabelProfessionalGroup | null
): void => {
  useEffect(() => {
    ghlAffiliate.initialize({
      enabled: professionalGroup?.ghl_affiliate_enabled,
      locationId: professionalGroup?.ghl_affiliate_location_id,
    });
  }, [professionalGroup]);
};
